module.exports = __webpack_public_path__ + "static/img/theme_5.2973ad12.png";